import { jsxs as K, jsx as S } from "react/jsx-runtime";
import { useDatePicker as Y } from "@rehookify/datepicker";
import { addMonths as T, subMonths as I } from "date-fns";
import { useState as D, useCallback as f, useEffect as q } from "react";
import { DATEPICKER_PANEL_DATE_TESTID as z } from "./index.es2485.js";
import { calcCalendarOffset as J, calcViewValue as y, calcInitViewValue as Q } from "./index.es2483.js";
import o from "./index.es5722.js";
/* empty css             */
import { useDatePicker as U } from "./index.es851.js";
import p from "classnames";
import { DatePanelView as R } from "./index.es5724.js";
const n = 0, c = 1, ie = () => {
  const {
    minDate: m,
    maxDate: s,
    startDate: d,
    endDate: g,
    id: M,
    TODAY: i,
    setSelectedRangeData: w,
    selectedRangeData: V,
    weekStartingDay: _,
    variant: u
  } = U(), h = [
    V.value[0] || i,
    V.value[1] || i
  ], [t, x] = D(h), [A, L] = D(h), [N, $] = D(1), [b, P] = D(d ?? i), j = `${z}${M}`, G = f(
    (e) => {
      if (L(e), e.length === 2) {
        const a = {
          value: [e[n], e[c]],
          activePanel: "date-range"
        };
        w(a);
      }
    },
    [w]
  ), {
    data: { weekDays: C, calendars: v },
    propGetters: { dayButton: E }
  } = Y({
    selectedDates: A,
    onDatesChange: G,
    onOffsetChange: P,
    offsetDate: b,
    dates: { mode: "range", minDate: m, maxDate: s, selectSameDate: !0 },
    calendar: {
      offsets: [N],
      startDay: _
    },
    locale: {
      locale: "en-us",
      day: "numeric"
    }
  }), l = f((e) => {
    P(e[n]), $(J(e[n], e[c])), x(e);
  }, []), k = f(
    (e, a) => {
      const r = a === "left" ? y(e, t[c], a, s, m) : y(t[n], e, a, s, m);
      l(r);
    },
    [s, m, t, l]
  ), O = f(
    (e) => {
      const a = e ? T : I, r = [
        a(t[n], 1),
        a(t[c], 1)
      ];
      l(r);
    },
    [t, l]
  );
  q(() => {
    const e = d || I(i, 1), a = g || T(e, 1), r = Q(e, a, s);
    l(r);
  }, [d, g, s, i, l]);
  const B = p(o.rangePanelsContainer, {
    [o.collapsed]: u === "collapsed"
  }), F = p(o.leftDatePanel, {
    [o.collapsed]: u === "collapsed"
  }), H = p(o.rightDatePanel, {
    [o.collapsed]: u === "collapsed"
  });
  return /* @__PURE__ */ K("div", { className: B, "data-testid": j, children: [
    /* @__PURE__ */ S(
      R,
      {
        position: "left",
        classnames: F,
        calendar: v[n],
        viewValue: t[n],
        dayButton: E,
        weekDays: C,
        onViewChange: k,
        incrementOrDecrementMonth: O
      }
    ),
    /* @__PURE__ */ S(
      R,
      {
        position: "right",
        classnames: H,
        calendar: v[c],
        viewValue: t[c],
        dayButton: E,
        weekDays: C,
        onViewChange: k,
        incrementOrDecrementMonth: O
      }
    )
  ] });
};
export {
  ie as DatePickerPanel
};
//# sourceMappingURL=index.es5711.js.map
